"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRootCauseEntity = exports.useRootCauseDisplayValue = exports.getCategorizedRootCausesAsOptions = void 0;
var _hooks = require("../../state/redux/hooks");
var _issueRootCauses = require("../../state/redux/ducks/issueRootCauses");
const rootCauseToDropdownOption = rootCause => {
  return {
    label: rootCause.title,
    value: rootCause.id,
    rootCauseCategoryId: rootCause.rootCauseCategoryId
  };
};
const getCategorizedRootCausesAsOptions = categorizedRootCauses => {
  return categorizedRootCauses.map(rootCauseCategory => {
    return {
      label: rootCauseCategory.title,
      options: rootCauseCategory.rootCauses.map(rootCauseToDropdownOption)
    };
  }).filter(category => category.options.length > 0);
};
exports.getCategorizedRootCausesAsOptions = getCategorizedRootCausesAsOptions;
const useRootCauseEntity = rootCauseId => {
  const rootCauseEntitiesMap = (0, _hooks.useSelector)(_issueRootCauses.getIssueRootCausesEntitiesMap);
  if (!rootCauseId) {
    return undefined;
  }
  return rootCauseEntitiesMap[rootCauseId];
};
exports.useRootCauseEntity = useRootCauseEntity;
const useRootCauseDisplayValue = rootCauseId => {
  const rootCauseEntitiesMap = (0, _hooks.useSelector)(_issueRootCauses.getIssueRootCausesEntitiesMap);
  let rootCauseCategoryId;
  if (rootCauseId && rootCauseEntitiesMap[rootCauseId]) {
    rootCauseCategoryId = rootCauseEntitiesMap[rootCauseId].parentId;
  }
  const rootCause = useRootCauseEntity(rootCauseId);
  const rootCauseCategory = useRootCauseEntity(rootCauseCategoryId);
  if (rootCause && rootCauseCategory && rootCause.title && rootCauseCategory.title) {
    return "".concat(rootCauseCategory.title, " > ").concat(rootCause.title);
  }
};
exports.useRootCauseDisplayValue = useRootCauseDisplayValue;
//# sourceMappingURL=common.js.map